import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { Resume } from 'packages/types'
import { useUpdateResume } from 'builder/hooks/useUpdateResume'
import { useTourConfig } from 'builder/components/DocumentEditor/DocumentTour'
import { useOnboarding } from '../hooks/useOnboarding'

import LOADING_GIF from '../assets/loading.gif'
import { Container, Image, Progress, Text } from './styles'

const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export const Loading = () => {
  const navigate = useNavigate()
  const [progress, setProgress] = useState(1)
  const { resume } = useOnboarding()
  const { mutateAsync: updateResume } = useUpdateResume()
  const { startInitTourModal, setTourCompleted } = useTourConfig()

  const navigateToResumeEditor = async (resume: Resume) => {
    startInitTourModal()
    await updateResume({
      resume,
      payload: {
        name: 'data',
        value: { stepByStepFlow: { currentStep: null } },
      },
    })
    navigate(`/resumes/${resume?.id}/edit`)
  }

  const setProgressValue = async () => {
    await wait(2000)
    setProgress(70)
    await wait(1000)
    setProgress(90)
    await wait(2000)
    setProgress(100)
  }

  useEffect(() => {
    if (progress !== 100) return
    if (resume) {
      navigateToResumeEditor(resume as Resume)
    } else {
      setTourCompleted()
      navigate('/resumes')
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resume, progress])

  useEffect(() => {
    setProgressValue()
    trackInternalEvent('tr_lead_loading_screen')
  }, [])

  return (
    <Container data-testid="provision-users-loading">
      <Image src={LOADING_GIF} data-testid="loading-image" />
      <Text data-testid="loading-text">Preparing your resume for editing...</Text>
      <Progress value={progress} max={100} />
    </Container>
  )
}
